import FiltersDrawer, {
	FieldValue,
	FiltersField,
	Operations,
	retrieveValueFromFieldName,
} from "../../common/components/FiltersDrawer";
import FluidSelectMultiple from "../../common/components/FluidSelectMulti";
import MultiNumberInput from "../../common/components/MultiNumberInput";
import SelectAutocomplete from "../../common/components/SelectAutocomplete";
import { noop } from "../../common/utils/operations";
import {
	ChangeRequestStatus,
	ChangeRequestResourceType,
} from "../../requests_cm/gepoChangeRequestService/types";
import { useGetUsersQuery } from "../../requests_cm/gepoUserService/service";
import { Groups } from "../authentication/authentication.constant";

const ChangeRequestFilters = ({
	isOpen,
	onClose,
	defaultFilters = {},
	onApplyFilters,
}: {
	isOpen: boolean;
	onClose: () => void;
	onApplyFilters: (data: Record<string, FieldValue>) => void;
	defaultFilters?: Record<string, FieldValue>;
}) => {
	const { data: users = [] } = useGetUsersQuery();
	const { data: traders = [] } = useGetUsersQuery({
		group_filter: Groups.trader,
	});

	const toUserItems = (list: typeof users) =>
		list.map((user) => ({
			value: String(user.id),
			label: user.name,
		}));

	return (
		<FiltersDrawer
			title={"Change Request Filters"}
			isOpen={isOpen}
			onClose={onClose}
			onApplyFilters={onApplyFilters}
			defaultFilters={defaultFilters}
		>
			<FiltersField
				name={"status"}
				label="Status"
				defaultOperation={Operations.IN}
				defaultFieldValue={
					retrieveValueFromFieldName("status", defaultFilters) || []
				}
				allowedOperations={[Operations.IN]}
				selector={(data: string) => data}
				Input={
					<FluidSelectMultiple
						isLabelStatic
						items={[
							{
								value: ChangeRequestStatus.PENDING,
								label: "Pending",
							},
							{
								value: ChangeRequestStatus.REJECTED,
								label: "Refused",
							},
							{
								value: ChangeRequestStatus.CORRECTION_NEEDED,
								label: "Correction needed",
							},
							{
								value: ChangeRequestStatus.VALID,
								label: "Valid",
							},
							{
								value: ChangeRequestStatus.CLOSED,
								label: "Closed",
							},
						]}
						label={"status"}
						name={"Status"}
						onChange={noop}
						value={[]}
					/>
				}
			/>
			<FiltersField
				name={"resource_type"}
				label="Resource type"
				defaultOperation={Operations.IN}
				defaultFieldValue={
					retrieveValueFromFieldName(
						"resource_type",
						defaultFilters
					) || []
				}
				allowedOperations={[Operations.IN]}
				selector={(data: string) => data}
				Input={
					<FluidSelectMultiple
						isLabelStatic
						items={[
							{
								value: ChangeRequestResourceType.CONTRACT,
								label: "Contract",
							},
							{
								value: ChangeRequestResourceType.CONTRACT_PERIOD,
								label: "Contract period",
							},
							{
								value: ChangeRequestResourceType.HORIZON_CHANGE,
								label: "Horizon change",
							},
						]}
						label={"resource_type"}
						name={"Resource type"}
						onChange={noop}
						value={[]}
					/>
				}
			/>
			<FiltersField
				name={"requester_id"}
				label="Requester"
				defaultOperation={Operations.EQ}
				defaultFieldValue={
					retrieveValueFromFieldName(
						"requester_id",
						defaultFilters
					) || ""
				}
				allowedOperations={[Operations.EQ]}
				selector={(id: string) => id}
				Input={
					<SelectAutocomplete
						items={toUserItems(users)}
						label={"requester"}
						placeholder={"Search a requester"}
					/>
				}
			/>
			<FiltersField
				name={"validator_id"}
				label="Validator"
				defaultOperation={Operations.EQ}
				defaultFieldValue={
					retrieveValueFromFieldName(
						"validator_id",
						defaultFilters
					) || ""
				}
				allowedOperations={[Operations.EQ]}
				selector={(id: string) => id}
				Input={
					<SelectAutocomplete
						items={toUserItems(traders)}
						label={"validator"}
						placeholder={"Search a validator"}
					/>
				}
			/>
			<FiltersField
				name={"resource_id"}
				label="Resource id"
				defaultOperation={Operations.IN}
				defaultFieldValue={
					retrieveValueFromFieldName("resource_id", defaultFilters) ||
					[]
				}
				allowedOperations={[Operations.IN]}
				selector={(values: string[]) => values}
				Input={
					<MultiNumberInput
						label="resource ids"
						placeholder="Type an id and press Enter"
					/>
				}
			/>
		</FiltersDrawer>
	);
};

export default ChangeRequestFilters;
